// eslint-disable-next-line

import { RegimeValues, MomentValues, StructureValues } from 'src/types'

import { NutritionalPreferences, OnboardingStepType } from '../../types'
import { wysiwygTransformer } from '../../utils/DomUtils'

// Preferences
export type PrettyPreferencesObjectType = {
  [key: string]: string
}

function getPrettyPreferencesObject(
  preferenceOptions: { id: any; label: string }[]
) {
  const res: PrettyPreferencesObjectType = {}
  preferenceOptions.forEach(({ id, label }) => {
    if (typeof id === 'boolean') {
      return (res[id ? 'true' : 'false'] = label)
    }
    return (res[id] = label)
  })
  return res
}

export const PEOPLE_COUNT_STEP = (t?: any, tips?: any, stepsValues?: any) => ({
  type: OnboardingStepType.NUMBER,
  name: NutritionalPreferences.PEOPLE_COUNT,
  min: 1,
  max: 16,
  title: t('onboarding_step_people_count_title'),
  peopleCountText: t('onboarding_step_people_count_legend', {
    count: stepsValues[NutritionalPreferences.PEOPLE_COUNT],
  }),
  image: {
    src: '/images/onboarding/plate.png',
    alt: '',
    height: 342,
    width: 480,
  },
  texts: (
    <>
      <p>{t('onboarding_step_people_count_text')}</p>
    </>
  ),
  tip: {
    title: t('onboarding_tip_title_did_you_know'),
    content: wysiwygTransformer(
      tips?.[NutritionalPreferences.PEOPLE_COUNT] ?? ''
    ),
  },
})

export const DIET_PRACTICE_STEP = (
  t?: any,
  tips?: any,
  getOptions?: boolean
) => {
  const options = [
    { id: RegimeValues.NONE, label: t('onboarding_step_diet_practice_none') },
    {
      id: RegimeValues.NO_PORK,
      label: t('onboarding_step_diet_practice_no_pork'),
    },
    {
      id: RegimeValues.NO_MEAT,
      label: t('onboarding_step_diet_practice_no_meat'),
    },
    //https://bigbossstudio.atlassian.net/browse/DF-295 Hide these options for the moment
    // {
    //   id: RegimeValues.NO_FISH,
    //   label: t('onboarding_step_diet_practice_no_fish'),
    // },
    // {
    //   id: RegimeValues.NO_EGG,
    //   label: t('onboarding_step_diet_practice_no_egg'),
    // },
  ]
  if (getOptions) {
    return getPrettyPreferencesObject(options)
  }
  return {
    type: OnboardingStepType.SLIDER,
    name: NutritionalPreferences.DIET_PRACTICE,
    options,
    title: t('onboarding_step_diet_practice_title'),
    image: {
      src: '/images/onboarding/proteins.png',
      alt: '',
      height: 342,
      width: 480,
    },
    texts: (
      <>
        <p>{t('onboarding_step_diet_practice_text')}</p>
      </>
    ),
    tip: {
      title: t('onboarding_tip_title_did_you_know'),
      tips,
      content: wysiwygTransformer(
        tips?.[NutritionalPreferences.DIET_PRACTICE] ?? ''
      ),
    },
  }
}

export const COURSE_COMPOSITION_STEP = (
  t?: any,
  tips?: any,
  getOptions?: boolean
) => {
  const options = [
    {
      id: StructureValues.ENT_PLAT,
      label: t('onboarding_step_course_composition_starter_meal'),
    },
    {
      id: StructureValues.ENT_PLAT_DESSERT,
      label: t('onboarding_step_course_composition_starter_meal_dessert'),
    },
    {
      id: StructureValues.PLAT_DESSERT,
      label: t('onboarding_step_course_composition_meal_dessert'),
    },
  ]
  if (getOptions) {
    return getPrettyPreferencesObject(options)
  }
  return {
    type: OnboardingStepType.RADIO,
    name: NutritionalPreferences.COURSE_COMPOSITION,
    options,
    title: t('onboarding_step_course_composition_title'),
    image: {
      src: '/images/onboarding/full-meal.png',
      alt: '',
      height: 342,
      width: 480,
    },
    texts: (
      <>
        <p>{t('onboarding_step_course_composition_text')}</p>
      </>
    ),
    tip: {
      title: t('onboarding_tip_title_did_you_know'),
      content: wysiwygTransformer(
        tips?.[NutritionalPreferences.COURSE_COMPOSITION] ?? ''
      ),
    },
  }
}

export const EXPRESS_STEP = (t?: any, tips?: any, getOptions?: boolean) => {
  const isDisabled = false
  const options = [
    {
      id: true,
      label: t('onboarding_step_express_express') + (isDisabled ? ' *' : ''),
      disabled: isDisabled,
    },
    {
      id: false,
      label: t('onboarding_step_express_non_express'),
    },
  ]
  if (getOptions) {
    return getPrettyPreferencesObject(options)
  }
  return {
    type: OnboardingStepType.RADIO,
    name: NutritionalPreferences.EXPRESS,
    options,
    title: t('onboarding_step_express_title'),
    image: {
      src: '/images/onboarding/egg-timer.png',
      alt: '',
      height: 342,
      width: 480,
    },
    texts: (
      <>
        <p>{t('onboarding_step_express_text')}</p>
      </>
    ),
    /*...(isDisabled && {
      legend: t('onboarding_step_express_legend'),
    }),*/
    tip: {
      title: t('onboarding_tip_title_did_you_know'),
      content: wysiwygTransformer(tips?.[NutritionalPreferences.EXPRESS] ?? ''),
    },
  }
}
export const COURSE_RANGE_STEP = (
  t?: any,
  tips?: any,
  getOptions?: boolean
) => {
  const options = [
    {
      id: MomentValues.ONLY_LUNCH,
      label: t('onboarding_step_course_range_lunch'),
    },
    {
      id: MomentValues.LUNCH_AND_DINNER,
      label: t('onboarding_step_course_range_lunch_dinner'),
    },
    {
      id: MomentValues.ONLY_DINNER,
      label: t('onboarding_step_course_range_dinner'),
    },
  ]

  if (getOptions) {
    return getPrettyPreferencesObject(options)
  }

  return {
    type: OnboardingStepType.RADIO,
    name: NutritionalPreferences.COURSE_RANGE,
    image: {
      src: '/images/onboarding/clock.png',
      alt: '',
      height: 342,
      width: 480,
    },
    options,
    title: t('onboarding_step_course_range_title'),
    texts: (
      <>
        <p>{t('onboarding_step_course_range_text')}</p>
      </>
    ),
    tip: {
      title: t('onboarding_tip_title_did_you_know'),
      content: wysiwygTransformer(
        (tips?.[NutritionalPreferences.COURSE_RANGE] || tips?.course_range) ??
          ''
      ),
    },
  }
}
